import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea", "previewContainer"];

  readFile(event) {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.name.endsWith(".svg") && file.type !== "image/svg+xml") return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.textareaTarget.value = e.target.result;
      this.render();
    };
    reader.readAsText(file);
  }

  render() {
    if (!this.hasPreviewContainerTarget) return;

    const sanitized = this.sanitizeSvg(this.textareaTarget.value);
    this.previewContainerTarget.replaceChildren();

    if (sanitized) {
      this.previewContainerTarget.appendChild(sanitized);
    } else {
      const placeholder = document.createElement("p");
      placeholder.className = "text-sm text-gray-400 dark:text-neutral-500";
      placeholder.textContent = "SVG preview will appear here";
      this.previewContainerTarget.appendChild(placeholder);
    }
  }

  sanitizeSvg(raw) {
    if (!raw || !raw.trim()) return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(raw, "image/svg+xml");
    if (doc.querySelector("parsererror")) return null;

    const svg = doc.querySelector("svg");
    if (!svg) return null;

    svg.querySelectorAll("script, foreignObject").forEach((el) => el.remove());

    const walk = (node) => {
      for (const attr of [...node.attributes]) {
        if (attr.name.startsWith("on")) node.removeAttribute(attr.name);
      }
      for (const child of node.children) walk(child);
    };
    walk(svg);

    return svg;
  }
}
